import GetTransactionByIdRequestModelBase from '../_generated/modelBases/get-transaction-by-id-request-model-base';

export default class GetTransactionByIdRequestModel extends GetTransactionByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
